import React, { useEffect, useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  FetchFinancialByProject,
  FetchQuotes,
  AddSection,
  getQuoteSections,
  QuoteExtraWorkValidation,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import {
  europeanFormat,
  europeanFormatWithSymbol,
} from "../../utils/European-Format/NumberFormatter";
import Plus from "../../assets/icons/Plus.svg";
import Xcircle from "../../assets/icons/x-circle.svg";
import searchicon from "../../assets/icons/search.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Financial = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [extraWorkPopup, setExtraWorkPopup] = useState(false);

  const [financialDetails, setFinancialDetails] = useState({
    revenueTotal: 0,
    revenueBtwTotal: 0,
    invoicedTotal: 0,
    invoicedBtwTotal: 0,
    quotesTotal: 0,
    approvedQuotesTotal: 0,
    provisionalTotal: 0,
    realisationTotal: 0,
    extraWorkTotal: 0,
    costsTotal: 0,
  });

  const FetchFinancialByProjectResponse = useSelector(
    (state) => state.user.FetchFinancialByProjectResponse
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    const projectId = window.localStorage.getItem("projectid");
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
    dispatch(FetchFinancialByProject(projectId));
    dispatch(FetchQuotes(projectId, 0, 0));
  }, []);

  useEffect(() => {
    if (FetchFinancialByProjectResponse.status) {
      setFinancialDetails(FetchFinancialByProjectResponse?.data);
    }
  }, [FetchFinancialByProjectResponse]);

  return (
    <div>
      <div className="finance-main-container finance-hero-container">
        <div className="finance-top-grid">
          <section className="finance-single-el">
            {/* <p>Revenue</p> */}
            <div>
              <p>{t("Revenue")}</p>
              {<p className="inclBtw">{t("Incl BTW")}</p>}
            </div>
            <div>
              <p style={{ fontWeight: "800" }}>
                {europeanFormatWithSymbol(financialDetails.revenueTotal)}
              </p>
              {
                <p className="inclBtw">
                  {europeanFormatWithSymbol(financialDetails.revenueBtwTotal)}
                </p>
              }
            </div>
          </section>
          <section
            className="finance-single-el hidefor-Mobile"
            style={{ minWidth: "13rem" }}
          >
            {/* <p>Invoiced</p> */}
            <div>
              <p>{t("Invoiced")}</p>
              {<p className="inclBtw">{t("Incl BTW")}</p>}
            </div>
            <div>
              <p style={{ fontWeight: "800" }}>
                {europeanFormatWithSymbol(financialDetails.invoicedTotal)}
              </p>
              {
                <p className="inclBtw">
                  {europeanFormatWithSymbol(financialDetails.invoicedBtwTotal)}
                </p>
              }
            </div>
          </section>
          <div className="mobile-container01">
            <section className="finance-single-el-2 finance-single-scroll-1">
              <article className="finance-flex-column">
                <p className="finance-flex-p">
                  {/* Quotes <br /> Approved */}
                  {t("Quotes")}
                  <br />
                  {t("Approved")}
                </p>
                <CircleProgressBar
                  value={financialDetails.approvedQuotesTotal}
                  maxValue={financialDetails.quotesTotal}
                />
                <p className="finance-flex-p" style={{ fontWeight: "bolder" }}>
                  {europeanFormatWithSymbol(
                    financialDetails.approvedQuotesTotal,
                  )}
                  <br />
                  <span className="see-details-text">
                    {/* See Details... */}
                    {t("See Details...")}
                  </span>
                </p>
              </article>

              <article className="finance-flex-column2 hide-on-mobile hide-on-tablet">
                <p className="finance-flex-p">
                  {/* Provisional */}
                  {t("Provisional")}
                </p>
                <article class="financial-round-gray border-0 pt-5">
                  <p className="fininitial">
                    {/* Initial */}
                    {t("Initial")}
                  </p>
                  <p className="fininitial2 pt-2">
                    {europeanFormatWithSymbol(
                      financialDetails.provisionalTotal,
                    )}
                  </p>
                </article>
                <p className="fininitial mt-0 pt-0">
                  {/* Realisation */}
                  {t("Realisation")}
                </p>
                <p className="finance-flex-p" style={{ fontWeight: "bolder" }}>
                  {europeanFormatWithSymbol(financialDetails.realisationTotal)}
                  <br />
                  <span
                    className="see-details-text"
                    onClick={() =>
                      history.push("/ProvisionalDetails", "from_Provisional")
                    }
                  >
                    {/* See Details... */}
                    {t("See Details...")}
                  </span>
                </p>
              </article>

              <article className="finance-flex-column hide-on-mobile hide-on-tablet">
                <p className="finance-flex-p">
                  {/* Extra work */}
                  {t("Extra Work")}
                </p>
                <CircleProgressBar
                  value={financialDetails.extraWorkTotal}
                  maxValue={financialDetails.approvedQuotesTotal}
                />
                <p className="finance-flex-p" style={{ fontWeight: "bolder" }}>
                  {europeanFormatWithSymbol(financialDetails.extraWorkTotal)}
                  <br />
                  <span className="see-details-text">
                    <img
                      src={Plus}
                      alt=""
                      onClick={() => {
                        setExtraWorkPopup(!extraWorkPopup);
                      }}
                    />
                  </span>
                </p>
              </article>

              <article className="finance-flex-column">
                <p className="finance-flex-p">
                  {/* Costs */}
                  {t("Costs")}
                </p>
                <CircleProgressBar
                  value={financialDetails.costsTotal}
                  maxValue={financialDetails.revenueTotal}
                />
                <p className="finance-flex-p" style={{ fontWeight: "bolder" }}>
                  {europeanFormatWithSymbol(financialDetails.costsTotal)}
                  <br />
                  <span
                    className="see-details-text"
                    onClick={() => history.push("/financial-cost-details")}
                  >
                    {/* See Details... */}
                    {t("See Details...")}
                  </span>
                </p>
              </article>
              <article className="finance-flex-column">
                <p className="finance-flex-p">
                  {/* Gross Profit */}
                  {t("Gross Profit")}
                </p>
                <CircleProgressBar
                  value={
                    financialDetails.revenueTotal - financialDetails.costsTotal
                  }
                  maxValue={financialDetails.revenueTotal}
                />
                <p className="finance-flex-p" style={{ fontWeight: "bolder" }}>
                  {europeanFormatWithSymbol(
                    financialDetails.revenueTotal - financialDetails.costsTotal,
                  )}
                </p>
              </article>
            </section>
          </div>
          <div className="onlyshownin-Mobile">
            <section
              className="finance-single-el"
              style={{ minWidth: "13rem" }}
            >
              {/* <p>Invoiced</p> */}
              <div>
                <p>{t("Invoiced")}</p>
                {<p className="inclBtw">{t("Incl BTW")}</p>}
              </div>
              <div>
                <p style={{ fontWeight: "800" }}>
                  {europeanFormatWithSymbol(financialDetails.invoicedTotal)}
                </p>
                {
                  <p className="inclBtw">
                    {europeanFormatWithSymbol(
                      financialDetails.invoicedBtwTotal,
                    )}
                  </p>
                }
              </div>
            </section>
          </div>
          <article
            className="finance-flex-column toBeInvoice"
            style={{ paddingTop: "30px", minWidth: "13rem" }}
          >
            <p className="finance-flex-p">
              {/* To be Invoiced */}
              {t("To be Invoiced")}
            </p>
            <CircleProgressBar
              value={
                financialDetails.revenueTotal - financialDetails.invoicedTotal
              }
              maxValue={financialDetails.approvedQuotesTotal}
              color={"#95A7C6"}
            />
            <p
              className="finance-flex-p"
              style={{ fontWeight: "800", color: "#333333" }}
            >
              {europeanFormatWithSymbol(
                financialDetails.revenueTotal - financialDetails.invoicedTotal,
              )}
            </p>
          </article>
        </div>

        {/* SEND PROPS DATA TO ADD EXTRA WORK POPUP */}
        <AddExtraWork
          extraWorkPopup={extraWorkPopup}
          setExtraWorkPopup={setExtraWorkPopup}
          setFetchTranslationList={setFetchTranslationList}
          FetchTranslationList={FetchTranslationList}
        />
      </div>
    </div>
  );
};

const AddExtraWork = ({
  extraWorkPopup,
  setExtraWorkPopup,
  FetchTranslationList,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const quotes_Popup_Ref = useRef(null);
  const [quoteShowOptions, setQuoteShowOptions] = useState(false);
  const [quotesData, setQuotesData] = useState([]);
  const [quotecode, setQuotecode] = useState("");
  const [quoteid, setQuoteid] = useState("");
  const [searchQuotesCode, setSearchQuotesCode] = useState("");
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [indexposition, setIndexposition] = useState("");
  const t = (key) => FetchTranslationList?.[key] || "";

  const fetchQuotesResponse = useSelector(
    (state) => state.user.fetchQuotesResponse
  );

  const getQuoteSectionsResponse = useSelector(
    (state) => state.user.getQuoteSectionsResponse
  );

  const quoteExtraWorkValidation = useSelector(
    (state) => state.user.quoteExtraWorkValidation
  );

  useEffect(() => {
    if (fetchQuotesResponse.status === true) {
      setQuotesData(fetchQuotesResponse.data);
    }
  }, [fetchQuotesResponse]);

  useEffect(() => {
    if (
      getQuoteSectionsResponse.status === true &&
      quoteExtraWorkValidation.status !== true
    ) {
      setIndexposition(getQuoteSectionsResponse.data.sections.length);

      dispatch(
        AddSection(
          quoteid,
          "EW - Extra Work",
          getQuoteSectionsResponse.data.sections.length
        )
      );
    }
  }, [getQuoteSectionsResponse]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      quotes_Popup_Ref.current &&
      !quotes_Popup_Ref.current.contains(event.target)
    ) {
      setQuoteShowOptions(false);
      setArrowOptionsRotate(false);
    }
  };

  return (
    <extraPopup className={extraWorkPopup ? "financialModa" : ""}>
      <div style={{ position: "relative" }}>
        <div
          className="extraWorkpop"
          style={{
            transform: extraWorkPopup ? "scale(1)" : "scale(0)",
            transitionDuration: "300ms",
          }}
        >
          <div className="d-flex addExtraWrk px-4 pt-3">
            <p className="">
              {/* Add Extra Work */}
              {t("Add Extra Work")}
            </p>
            <img
              src={Xcircle}
              className="xcircle pointer"
              alt=""
              onClick={() => {
                setExtraWorkPopup(false);
              }}
            />
          </div>

          <div className="d-flex quoteTxt pt-4">
            <p className="ps-4 pt-2">
              {/* Quote */}
              {t("7 Days")}
            </p>

            <searchSection>
              <div
                className="asc_Search_Box d-flex pt-2"
                ref={quotes_Popup_Ref}
                style={{ width: "300px", height: "40px" }}
              >
                <p
                  className="asc_Client_Input_For_Long ps-3"
                  style={{ color: "#333333", fontWeight: "400" }}
                  onClick={() => {
                    setQuoteShowOptions(true);
                    setArrowOptionsRotate(true);
                  }}
                >
                  {/* {quotecode ? quotecode : "Choose a quote"} */}
                  {quotecode ? quotecode : t("Choose Quote")}
                </p>

                <img
                  src={DownArrowOption}
                  className={
                    arrowOptionsRotate ? "upArrow mt-1" : "downArrow mt-1"
                  }
                  alt=""
                  onClick={() => {
                    setQuoteShowOptions(!quoteShowOptions);
                    setArrowOptionsRotate(!arrowOptionsRotate);
                  }}
                />

                {quoteShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer"
                    style={{
                      borderTop: "none",
                      background: "white",
                      top: "35px",
                    }}
                  >
                    <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        id="asc_input"
                        className="asc_Search_Input"
                        // placeholder="Search..."
                        placeholder={t("Search")}
                        value={searchQuotesCode}
                        onChange={(e) => setSearchQuotesCode(e.target.value)}
                      />
                    </section>

                    <section
                      className="asc_Search_List pt-0 p-3"
                      id="ascSelectBox"
                    >
                      {quotesData
                        .filter((item) =>
                          item.quotecode
                            ?.toLowerCase()
                            .includes(searchQuotesCode.toLowerCase()),
                        )
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              className=""
                              onClick={() => {
                                setSearchQuotesCode("");
                                setQuotecode(item.quotecode);
                                setQuoteid(item.quoteid);
                                setQuoteShowOptions(false);
                                setArrowOptionsRotate(false);
                                dispatch(getQuoteSections(item.quoteid));
                                dispatch(
                                  QuoteExtraWorkValidation(item.quoteid),
                                );
                                setTimeout(() => {
                                  history.push(
                                    "/quote-calculation",
                                    `${item.quotecode}@@${item.quoteid}@@Change@@/financial`,
                                  );
                                }, 2000);
                              }}
                            >
                              <p
                                className={
                                  quoteid === item.quoteid
                                    ? "asc_Selected_Item ps-1"
                                    : "ps-1"
                                }
                              >
                                {`ID ${item.quotecode}`}
                              </p>
                            </div>
                          );
                        })}
                      {quotesData.length === 0 && (
                        <span className="noDataDisplay">
                          {/* No data to display! */}
                          {t("No data to display!\n")}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
            </searchSection>
          </div>
        </div>
      </div>
    </extraPopup>
  );
};

const CircleProgressBar = ({ value, maxValue, color }) => {
  // const percentage = (value / maxValue) * 100;
  const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
  return (
    <div style={{ width: 150, height: 150 }}>
      <CircularProgressbar
        value={value}
        maxValue={maxValue || 100}
        strokeWidth={10}
        text={percentage ? `${europeanFormat(percentage, 1)}%` : "0%"}
        styles={{
          path: {
            stroke: color || "#00246a",
          },
          trail: {
            strokeWidth: 3,
            stroke: "#F1F1F1",
          },
          text: {
            fill: color || "#00246a",
            fontWeight: "bolder",
            fontSize: 14,
          },
        }}
      />
    </div>
  );
};

export default Financial;
